import { Context } from '@nuxt/types'
import { LocaleMessageArray } from 'vue-i18n'
import validationMessages from 'vee-validate/dist/locale/en.json'
import { obfuscateEmails } from '~/helpers/LocalizeUtils'

export let data: LocaleMessageArray = {}

const r = require.context('./en-US', true, /\.json$/)
r.keys().forEach((d) => {
  const i = d.replace('./', '').replace('.json', '')
  data[i] = r(d)
})

data = obfuscateEmails(data)

// @ts-ignore
data._validations = validationMessages.messages

export default (context: Context) => {
  return new Promise((resolve) => {
    resolve(data)
  })
}
